import React, { useState, useEffect } from "react";

import { Spinner } from "react-bootstrap";
import { Label } from "reactstrap";
import { toast } from "react-toastify";
import { selectCurrentRoles } from "features/auth/authSlice";
import { useSelector } from "react-redux";
import Swal from "sweetalert2";
import {
  useGetFarmerAdminTradeByIdQuery,
  useFarmerAdminPostChatMutation,
} from "features/E-Mandi/EMandiApiSlice";
import {
  Box,
  Typography,
  TextField,
  Button,
  Modal,
  Grid,
  Avatar,
} from "@mui/material";
import ChatBubbleOutlineIcon from "@mui/icons-material/ChatBubbleOutline";
import CachedIcon from '@mui/icons-material/Cached';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

export default function BuyerNegotiaiteAdmin({ trade,type,organizationVal}) {
    console.log("type",type)
  const id = trade?.id;
  console.log("UserData",organizationVal)
  console.log("ide",id)
  const {
    data: getNegotiationChat,
    refetch: refetchChat,
  } = useGetFarmerAdminTradeByIdQuery(
    { id },
    {
      refetchOnMountOrArgChange: true,
    }
  );
 
  const [negotiationCreated] = useFarmerAdminPostChatMutation();
  const [loading, setLoading] = useState(false);
  const [negotiationStatus, setNegotiationStatus] = useState("");
  
  const [negotiatioanValues, setNegotiationValue] = useState({
    price_offered: "",
    message: "",
  });
  const [chatHistory, setChatHistory] = useState([]);
  const [showFields, setShowFields] = useState(false);
  const [loadingAccepted, setLoadingAccepted] = useState(false);
    useEffect(() => {
      if (getNegotiationChat) {
        const filteredChat=getNegotiationChat?.data?.negotiations?.filter((item)=>item.sender==="4"||item.sender==="2")
        setChatHistory(filteredChat);
        setNegotiationStatus(getNegotiationChat?.data)

       
      }

    }, [getNegotiationChat]);

  const handleChange = (e) => {
    setNegotiationValue({
      ...negotiatioanValues,
      [e.target.name]: e.target.value,
    });
  };
  const handleOk = (e) => {
    e.preventDefault();

    setLoading(true);
    let payload = {
      ...negotiatioanValues,
      trade_id: id,
      sender:type==="Buyer"?"4":"2",
      other_details: {
        name: trade.buyer,
        harvest_date:trade.harvest_date
    }
     
    };
    negotiationCreated({payload})
      .unwrap()
      .then((data) => {
        toast.success(`Trade Negotiated Successfully`);
        setNegotiationValue({
            price_offered: "",
            message: "",})
        setLoading(false);
        refetchChat()
      })
      .catch((error) => {
        toast.error(error?.data?.message);
        setLoading(false);
        return;
      });
  };
  const handleRefresh=()=>{
    refetchChat()
  }
  return (
    <section>
    
      <form onSubmit={handleOk}>
        <Box
          sx={{
          
            bgcolor: "#fff",
            borderRadius: "12px",
            p: 2,
          }}
        >
          <Grid container spacing={3}>
            <Grid item xs={5}>
              <Typography
                variant="h6"
                sx={{ fontWeight: "600", color: "#333", mb: 2 }}
              >
                Negotiate Price
              </Typography>

              <Box sx={{ mb: 2 }} className="d-flex justify-content-between">
                <Typography
                  variant="body1"
                  sx={{ fontWeight: "500", color: "#777" }}
                >
                  Quantity: {trade.quantity} {trade.unit_of_quantity}
                </Typography>
                <Typography
                  variant="body1"
                  sx={{ fontWeight: "500", color: "#777" }}
                >
                  Price: {trade.quoted_price}
                </Typography>
                </Box><Box>
                <Typography
                  variant="body2"
                  sx={{
                    color: "#555",
                    fontSize: "0.9rem",
                    mt: 2,
                  }}
                >
                  Start negotiating directly with the admin. Enter your proposed
                  price and a message to proceed.
                </Typography>
              </Box>

              <TextField
                label="Enter New Price"
                type="number"
                name="price_offered"
                value={negotiatioanValues.price_offered}
                className="mt-2"
                onChange={handleChange}
                fullWidth
                variant="outlined"
                required
                sx={{
                  mb: 2,
                  "& .MuiInputBase-root": {
                    borderRadius: "8px",
                  },
                }}
              />
              <TextField
                label="Message"
                onChange={handleChange}
                value={negotiatioanValues.message}
                 name="message"
                fullWidth
                multiline
                minRows={3}
                variant="outlined"
                required
                sx={{
                  mb: 3,
                  "& .MuiInputBase-root": {
                    borderRadius: "8px",
                  },
                }}
              />
             {negotiationStatus?.current_status==="Negotiation Approved"? 
            <Button
            variant="outlined"
            color="success"
            fullWidth
            style={{ textTransform: "none" }}
          >
            Negotiation Approved &nbsp; <CheckCircleIcon/>
          </Button>
              :<Button
                variant="contained"
                color="success"
                fullWidth
                style={{ textTransform: "none" }}
                type="submit"
              >
                Submit {loading && <Spinner size="sm" animation="border" />}
              </Button>}
              
             
            </Grid>

            <Grid
              item
              xs={7}
              sx={{
                display: "flex",
                flexDirection: "column",
              
              }}
            >
            
              {chatHistory?.length>0?
                 <Box
                 sx={{
                   textAlign: "center",
                   p: 3,
                   borderRadius: "8px",
                   backgroundColor: "#f9f9f9",
                   width: "100%",
                   height: "100%",
                 }}
               >
                  <Avatar
            sx={{
              width: 20,
              height: 20,
              bgcolor: "#e0e0e0",
              mb: 2,
              float:"right",cursor:"pointer"
            }}
            onClick={()=>handleRefresh()}
          >
            <CachedIcon
              fontSize="small"
              sx={{ color: "#888" }}
            />
          </Avatar>
                  <Typography variant="body1" sx={{ mb: 2, color: "#666" }}>
            Here are your previous negotiation messages. Continue the conversation to finalize the terms.
          </Typography>
              <div className="heightChat">
            {chatHistory?.map((data, index) => {
              return (
                <main class="msger-chat">
                  {/* {data.sender === "Buyer" ? ( */}
                  {type ==="Buyer" && data.sender==="4" || type ==="Admin" && data.sender==="2" ? (

                    <div class="msg right-msg">
                      <div
                        class="msg-img"
                        style={{
                          backgroundImage:
                            "url(https://image.flaticon.com/icons/svg/145/145867.svg)",
                        }}
                      ></div>

                      <div class="msg-bubble">
                        <div class="msg-info">
                          <div class="msg-info-name text-primary">
                            {organizationVal?.organization_name}
                          </div>
                        </div>

                        <h6 class="">
                            Price: ₹ {data.price_offered}
                         
                        </h6>
                        <h6 class=" text-gray">{data.message}</h6>

                        <div class="msg-info">
                          <div
                            class="msg-info-name text-primary "
                            style={{ visibility: "hidden" }}
                          >
                            {data.entity_type}
                          </div>
                          <div class="msg-info-time text-gray mt-1">
                            {/* {data.created_at.slice(0, 10)} */}
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div class="msg left-msg">
                      <div
                        class="msg-img"
                        style={{
                          backgroundImage:
                            "url(https://image.flaticon.com/icons/svg/327/327779.svg)",
                        }}
                      ></div>

                      <div class="msg-bubble">
                        <div class="msg-info">
                          <div class="msg-info-name text-primary">
                            {/* {UserType==="Buyer"?negotiationItem.seller_name:negotiationItem.buyer_name} */}

                          </div>
                        </div>

                        <h6 class="">
                            Price : ₹ {data.price_offered}
                         
                        </h6>
                        <h6 className="text-gray">{data.message}</h6>
                        <div class="msg-info">
                          <div
                            class="msg-info-name text-primary "
                            style={{ visibility: "hidden" }}
                          >
                            {data.entity_type}
                          </div>
                          <div class="msg-info-time text-gray mt-1">
                            {/* {data.created_at.slice(0, 10)} */}
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </main>
              );
            })}
          </div>
          </Box>
          :
          <Box
          sx={{
            textAlign: "center",
            p: 3,
            borderRadius: "8px",
            backgroundColor: "#f9f9f9",
            width: "100%",
            height: "100%",
          }}
        >
                <Avatar
            sx={{
              width: 20,
              height: 20,
              bgcolor: "#e0e0e0",
              mb: 2,
              float:"right",cursor:"pointer"
            }}
            onClick={()=>handleRefresh()}
          >
            <CachedIcon
              fontSize="small"
              sx={{ color: "#888" }}
            />
          </Avatar>
          <Avatar
            sx={{
              width: 80,
              height: 80,
              bgcolor: "#e0e0e0",
              mb: 2,
            }}
          >
            <ChatBubbleOutlineIcon
              fontSize="large"
              sx={{ color: "#888" }}
            />
          </Avatar>
          <Typography
            variant="h6"
            sx={{ fontWeight: "500", color: "#555" }}
          >
            No Messages Yet
          </Typography>
          <Typography variant="body2" sx={{ color: "#777", mt: 1 }}>
            Start your negotiation and your messages will appear here.
          </Typography>
        </Box>
          }
            </Grid>
          </Grid>
        </Box>
      </form>
      {/* )}
        </>
        } */}
    </section>
  );
}
